document.addEventListener('DOMContentLoaded', function () {
    // Initialize DataTables for hardcoded tables
    document.querySelectorAll('table.hardcoded-table').forEach(function (table) {
        if (table.dataset.datatables !== 'true') return;
        new DataTable(table, {
            paging: table.dataset.paging === 'true',
            pagingType: 'simple_numbers',
            searching: table.dataset.searching === 'true',
            ordering: table.dataset.ordering === 'true',
            pageLength: parseInt(table.dataset.pageLength, 10) || 10,
            autoWidth: false,
            responsive: true,
        });
    });
});
